import React from 'react';
import { components } from 'react-select';

const Input = (props) => (
  <components.Input {...props} isHidden={false} className="ws-ui-language-select-input" />
);

export default Input;
